import config from '@/config'
import axios from 'axios'
import mime from 'mime'
import {Message} from 'element-ui'
export default {
  data () {
    return {
      timeout: null
    }
  },
  methods: {
    submitForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    downFile (filename = '') {
      this._attachmentDown(filename)
    },
    _attachmentDown (filename = '') {
      if (!filename) {
        Message ({
          message: '下载失败,资源不存在或服务器错误',
          type: 'error',
          duration: 5 * 1000,
        });
      }
      window.open(`${config.baseUrl}web/web/attachmentDown?filename=${filename}`, '_blank')
    },
    _blodDown (filename = '') {
      axios.get(config.baseUrl + 'web/web/down', {
        params: {filename},
        responseType: 'arraybuffer',
      }).then(res => {
        let fileName = filename.substr(filename.lastIndexOf('/') + 1)
        if (res.status == 200) {
          let blob = new Blob([res.data], {
            type: mime.getType(filename)
          })
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let link = document.createElement("a");
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", false, false);
            link.href = URL.createObjectURL(blob); 
            link.download = fileName;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        } else {
          Message ({
            message: '下载失败,资源不存在或服务器错误',
            type: 'error',
            duration: 5 * 1000,
          });
        }
      }).catch(() => {
        Message ({
          message: '下载失败,资源不存在或服务器错误',
          type: 'error',
          duration: 5 * 1000,
        });
      })
    },
    debounce(func, wait = 500, immediate = true) {
      var result;
      func = this[func]
      var that = this
      var debounced = function () {
          var context = that;
          var args = arguments;
          if (that.timeout) clearTimeout(that.timeout);
          if (immediate) {
              var callNow = !that.timeout;
              that.timeout = setTimeout(function(){
                  that.timeout = null;
              }, wait)
              if (callNow) result = func.apply(context, args)
          }
          else {
              that.timeout = setTimeout(function(){
                  func.apply(context, args)
              }, wait);
          }
          return result;
      };

      debounced.cancel = function() {
          clearTimeout(this.timeout);
          this.timeout = null;
      };
      return debounced;
    }
  }
}